import React from "react"
import { Radio } from "antd"
import type { RadioGroupProps } from "antd/lib/radio"

export const RadioGroup = ({ children, ...props }: RadioGroupProps): JSX.Element => {
  return <Radio.Group {...props}>{children}</Radio.Group>
}
